import React from "react";
import { Box, Grid, Typography, useTheme, Paper, Button } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useNavigate, useParams } from "react-router-dom";
import fields from "../fields";
import { useAuth } from "../../../services/auth";

function BoxInfo({ client = [] }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const { role } = useAuth();

  const getData = (data) => {
    switch (data) {
      case "companyName":
        return client?.company?.companyName
          ? client?.company?.companyName
          : "";
      default:
        break;
    }
  };
  return (
    <Paper
      elevation={0}
      sx={{
        p: theme.dimensions.padding,
        mt: theme.dimensions.mt,
        mb: theme.dimensions.mb,
        background: theme.color.PaperbgColor,
        width: "90%",
      }}
    >
      <Typography variant="Poster" component="h4" gutterBottom>
        Client Information
      </Typography>
      <Grid container>
        {fields.map((f, index) => {
          if (f.editOnly) return [];
          return (
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              mt={2}
              key={index}
              sx={{ fontSize: "14px" }}
            >
              <span style={{ color: theme.color.PaperlabelColor }}>
                {f.label} :{" "}
              </span>
              <span>
                {client?.[f?.name] && client?.[f?.name]}
                {getData(f.viewLabel2)}
                {f.name === "isActive" &&
                  (client?.isActive ? (
                    <span style={{ color: "#4AA785" }}>
                      <FiberManualRecordIcon
                        fontSize="small"
                        sx={{ fontSize: 10, mr: 0.2 }}
                      />
                      Active
                    </span>
                  ) : (
                    <span style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                      <FiberManualRecordIcon
                        fontSize="small"
                        sx={{ fontSize: 10, mr: 0.2 }}
                      />
                      Inactive
                    </span>
                  ))}
              </span>
            </Grid>
          );
        })}
      </Grid>

      {role === "Admin" && (
        <Box sx={{ display: "flex", justifyContent: "end" }} mr={2}>
          <Button
            onClick={() => navigate("edit")}
            sx={{
              background: theme.color.blackBackground,
              color: "white",
              "&:hover": { background: `${theme.color.black}` },
            }}
          >
            Edit
          </Button>
        </Box>
      )}
      {role === "Company" && (
        <Box sx={{ display: "flex", justifyContent: "end" }} mr={2}>
          <Button
            onClick={() => navigate("edit")}
            sx={{
              background: theme.color.blackBackground,
              color: "white",
              "&:hover": { background: `${theme.color.black}` },
            }}
          >
            Edit
          </Button>
        </Box>
      )}
    </Paper>
  );
}

export default BoxInfo;